import BillBillingPeriodButtonProperties from "./BillBillingPeriodButtonProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import BillBillingPeriodStore from "./BillBillingPeriodStore";
import {Observer} from "mobx-react-lite";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import {useUserContext} from "../../../contexts/UserContext";
import React from "react";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import useConfirmation from "../../../hooks/ConfirmationDialog";
import LocalAtmIcon from '@mui/icons-material/LocalAtm';

const BillBillingPeriodButton: React.FC<BillBillingPeriodButtonProperties> = ({
                                                                  onClick = () => {
                                                                  },
                                                                  onSave = () => {
                                                                  },
                                                                  billingPeriodId,
                                                                  showIcon = true,
                                                                  showText = true,
                                                                  disabled,
                                                                  className = '',
                                                                  rounded = false,
                                                                  size = ButtonSize.DEFAULT,
                                                                  type = ButtonType.DEFAULT
                                                              }) => {
    const i18n = useI18nContext();
    const confirm = useConfirmation();
    const userStore = useUserContext();
    const commonContext = useCommonContext();
    const store = new BillBillingPeriodStore(commonContext, billingPeriodId);

    const handleOnclick = async () => {
        onClick();
        const ok = await confirm('Confirmación', i18n.translate("BILL_BILLING_PERIOD_CONFIRMATION"));
        if (ok) {
            await store.bill();
            onSave();
        }
    }

    if (!userStore.isRootAgency()) {
        return <></>;
    }

    const text = 'Facturar período';
    
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                size={size}
                type={type}
                icon={showIcon ? <LocalAtmIcon/> : <></>}
            />
        }
        return <Button
            onClick={handleOnclick}
            className={className}
            disabled={disabled}
            tooltip={!showText ? text : ""}
            text={showText ? text : ""}
            size={size}
            type={type}
            startIcon={showIcon ? <LocalAtmIcon/> : <></>}
        />
    }

    return <Observer>
        {() => (
            <>
                <Btn/>
            </>
        )}
    </Observer>
}

export default BillBillingPeriodButton;
